import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';
import AboutHero from './components/AboutHero';
import CompanyInfo from './components/CompanyInfo';
import Leadership from './components/Leadership';
import AboutCTA from './components/AboutCTA';

const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? '';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '会社概要 | 株式会社C.GREEN',
  url: `${siteUrl}/%E4%BC%9A%E7%A4%BE%E6%A6%82%E8%A6%81`,
  description:
    '株式会社C.GREENの会社概要・代表メッセージ・経営体制をご紹介します。廃校活用と循環型陸上養殖で地域創生に取り組む企業情報をご覧ください。',
  inLanguage: 'ja',
  about: {
    '@type': 'Organization',
    name: '株式会社C.GREEN',
    url: siteUrl,
  },
};

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="会社概要 | 株式会社C.GREEN | 廃校活用・地域創生"
        description="株式会社C.GREENの会社概要・代表メッセージ・経営体制をご紹介します。廃校活用と循環型陸上養殖で地域創生に取り組む企業情報をご覧ください。"
        keywords="C.GREEN会社概要,代表取締役,経営体制,廃校活用,地域創生,陸上養殖企業"
        canonicalPath="/%E4%BC%9A%E7%A4%BE%E6%A6%82%E8%A6%81"
        jsonLd={aboutJsonLd}
      />
      <Navbar />
      <AboutHero />
      <CompanyInfo />
      <Leadership />
      <AboutCTA />
      <Footer />
    </div>
  );
}
